<input
  [formControl]="control"
  [disabled]="disabled"
  [placeholder]="placeholder"
  class="form-control"
  [type]="visible ? 'text' : 'password'"
/>
<span (click)="onToggleVisibility()" class="cm-link" [ngClass]="{ disabled: !control.value }">
    {{ visible ? 'Hide' : 'Show' }}
</span>

